let browserSupabasePromise: Promise<any> | null = null;

export async function getBrowserSupabase() {
  if (typeof window === "undefined") {
    throw new Error("Browser Supabase client requested during SSR");
  }

  if (!browserSupabasePromise) {
    browserSupabasePromise = import("@/integrations/supabase/client").then((module) => module.supabase);
  }

  return browserSupabasePromise;
}
